document.addEventListener("DOMContentLoaded", function () {
  const questions = document.querySelectorAll(".faq-question");

  questions.forEach((btn) => {
    btn.addEventListener("click", () => {
      const answer = btn.nextElementSibling;
      const isVisible = answer.style.display === "block";
      document.querySelectorAll(".faq-answer").forEach((el) => (el.style.display = "none"));
      answer.style.display = isVisible ? "none" : "block";
    });
  });
});
